const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
const DATE_FMT = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})
const DATETIME_FMT = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

export const formatCurrency = (value: number | null | undefined): string => BRL.format(value ?? 0)

export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return '—'
  return DATE_FMT.format(typeof date === 'string' ? new Date(date) : date)
}

export const formatDatetime = (date: string | Date | null | undefined): string => {
  if (!date) return '—'
  return DATETIME_FMT.format(typeof date === 'string' ? new Date(date) : date)
}

export const formatPercent = (value: number | null | undefined, decimals = 0): string =>
  `${(value ?? 0).toFixed(decimals)}%`

export const formatArea = (value: number | null | undefined): string =>
  value != null ? `${value} m²` : '—'

export const slugify = (text: string): string =>
  text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')

/** Formata número para input monetário pt-BR (sem símbolo R$). */
export function formatMoneyInput(value: number): string {
  if (!Number.isFinite(value) || value === 0) return ''
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/** Converte string digitada (pt-BR) em número. */
export function parseMoneyInput(raw: string): number {
  const digits = raw.replace(/\D/g, '')
  if (!digits) return 0
  return Number(digits) / 100
}
